module.exports = __webpack_public_path__ + "img/moments.910383e4.png";